import HeroWithText from "./HeroWithText";

export default HeroWithText;
